import { render, staticRenderFns } from "./AgriIndex200.vue?vue&type=template&id=44920d78&scoped=true"
import script from "./AgriIndex200.vue?vue&type=script&lang=js"
export * from "./AgriIndex200.vue?vue&type=script&lang=js"
import style0 from "./AgriIndex200.vue?vue&type=style&index=0&id=44920d78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44920d78",
  null
  
)

export default component.exports